var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-0",style:({
    height: _vm.elemHeight,
    paddingRight: _vm.pdfViewerContainerPadding,
    paddingTop: _vm.pdfViewerContainerPadding,
    paddingLeft: _vm.pdfViewerContainerPadding,
  }),attrs:{"id":"pdfviewer-container"}},[_c('ag-pdf-page',{key:_vm.currentPage})],1)}
var staticRenderFns = []

export { render, staticRenderFns }